import replaceBlankName from './replaceBlankName';
/**
 * Return the contact name if it has been formatted already as name or format it
 * if it is still in the first_name and last_name format
 *
 * @param   {Object} contact contact
 * @returns {String} returns contacts name, or if this doesn't exist, the unnamed placeholder
 */
export default function(contact) {
  const contactName = contact && contact.name && contact.name.value ? contact.name.value : `${contact.first_name} ${contact.last_name}`;
  return replaceBlankName(contactName);
}
